const basePath = "infrastructure-environmental-systems/";

export const cybersecuritySoftware = {
  id: 8,
  category: "Cybersecurity Software",

  filters: {
    Brand: { type: "checkbox" },
    Type: { type: "checkbox" },
    Features: { type: "checkbox" },
    Methods: { type: "checkbox" },
  },

  subcategories: [
    {
      name: "SIEM Platforms (Security Information & Event Management)",
      bestSeller: false,
      image: `${basePath}SIEM_Platforms_(Security_Information_&_Event_Management).png`,
      details: {
        Brand: "Splunk/ArcSight/QRadar",
        Type: "Security Analytics",
        Features: "Log aggregation, threat detection, compliance reporting",
      },
      about: `
        <ul>
          <li>Centralized log management and security analytics for threat detection and response.</li>
          <li>Aggregate logs from all infrastructure components; enable compliance audits.</li>
        </ul>
      `,
    },
    {
      name: "PAM Solutions (Privileged Access Management)",
      bestSeller: false,
      image: `${basePath}PAM_Solutions_(Privileged_Access_Management).png`,
      details: {
        Brand: "CyberArk/Delinea/BeyondTrust",
        Type: "Credential Management",
        Features: "Vault, session recording, risk analytics",
      },
      about: `
        <ul>
          <li>Secure management of admin credentials and privileged user access.</li>
          <li>Enable audit trails and reduce insider threat risk.</li>
        </ul>
      `,
    },
    {
      name: "IAM Platforms (Identity & Access Management)",
      bestSeller: false,
      image: `${basePath}IAM_Platforms_Identity_Access_Management.svg`,
      details: {
        Brand: "Okta/Ping Identity/Microsoft Entra",
        Type: "User Authentication & Authorization",
        Features: "SSO, MFA, directory integration",
      },
      about: `
        <ul>
          <li>Centralized identity and access control for infrastructure and data center systems.</li>
          <li>Support SSO, MFA, and conditional access policies.</li>
        </ul>
      `,
    },
    {
      name: "MFA Systems (Multi-Factor Authentication)",
      bestSeller: false,
      image: `${basePath}MFA_Systems_(Multi-Factor_Authentication).png`,
      details: {
        Brand: "Okta/Duo/Microsoft",
        Type: "Authentication Factor Service",
        Methods: "OTP, SMS, Push, FIDO2",
        Features: "Risk-based, adaptive",
      },
      about: `
        <ul>
          <li>Multi-factor authentication platforms protecting admin and user access.</li>
          <li>Support various authentication methods; reduce credential compromise risk.</li>
        </ul>
      `,
    },
    {
      name: "EDR / EPP Solutions (Endpoint Detection & Response)",
      bestSeller: false,
      image: `${basePath}EDR___EPP_Solutions_(Endpoint_Detection_&_Response).png`,
      details: {
        Brand: "CrowdStrike/Microsoft Defender/SentinelOne",
        Type: "Endpoint Security",
        Features: "Behavioral analysis, threat hunting, incident response",
      },
      about: `
        <ul>
          <li>Endpoint security platforms protecting servers and workstations from malware and intrusions.</li>
          <li>Provide threat intelligence and automated incident response capabilities.</li>
        </ul>
      `,
    },
  ],
};
